import React from 'react';
import withIcon from '../utilities/withIcon';

const IconListBulleted = () => {
  return (
    <g>
      <path d="m5.56 3.3535 9.6226-.0029a.75.75 0 0 0 0-1.5l-9.6226.0029a.75.75 0 1 0 0 1.5z" />
      <circle cx="1.3556" cy="2.5735" r="1.2876" />
      <path d="m15.1821 7.2774-9.6221.0019a.75.75 0 0 0 0 1.5l9.6226-.002a.75.75 0 0 0 0-1.5z" />
      <circle cx="1.3556" cy="8" r="1.2877" />
      <path d="m15.1821 12.7031-9.6221.003a.75.75 0 0 0 0 1.5l9.6226-.0029a.75.75 0 0 0 0-1.5z" />
      <circle cx="1.3556" cy="13.4265" r="1.2877" />
    </g>
  );
};

export default withIcon(IconListBulleted);
